import type { CitationSourceLinkProps } from "@op/puck-types";
import { Dc_Text_Citation } from "@op/sf-op";
import { transformDoiOrUrl } from "@op/utils";
import { useTranslation } from "@op/utils";

const CitationSourceLink = ({ citation }: CitationSourceLinkProps) => {
  if (!citation.source) return null;
  const { citation: trans } = useTranslation();

  return (
    <a target="_blank" href={transformDoiOrUrl(citation.source)}>
      <Dc_Text_Citation.SourceButton>
        {trans.viewSource}
      </Dc_Text_Citation.SourceButton>
    </a>
  );
};

export default CitationSourceLink;
